import lowerCase from 'lodash/lowerCase';
import Config from 'react-native-config';
import {
  FeedbackFormValues,
  QualtricsSession,
  SESSION_URL,
  SHARE_FEEDBACK_SCENARIOS,
  ShareFeedbackScenarios
} from 'lib/constants/help';
import { SESSION_URL as HEALTHTOOLS_SESSION_URL } from 'lib/healthTools/constants';
import { SurveyForm, HEALTH_TOPICS_CHECKBOXES } from 'lib/healthTools/types';
import { AppName, getAppName } from 'modules/utils/ConfigUtils';

/**
 * Get Qualtrics Session GET Request
 *
 * To fill out any qualtrics form through the API, you'll need to start
 * a qualtrics session.
 */
export async function getQualtricsSession(URL: string) {
  const body = JSON.stringify({ language: 'EN' });
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-TOKEN': Config.QUALTRICS_API_TOKEN
    },
    body
  };

  const response = await window.fetch(URL, requestOptions);
  return response.json();
}

/**
 * Update Qualtrics Session | Submit Feedback Form
 */
export async function updateQualtricsSession(
  formValues: FeedbackFormValues,
  session: QualtricsSession
) {
  const questions = session?.result?.questions;
  const showContact = formValues?.showContact;
  const body = JSON.stringify({
    advance: true,
    responses: {
      [questions?.[0]?.questionId]: formValues.feedback,
      [questions?.[1]?.questionId]: showContact ? formValues.name : '',
      [questions?.[2]?.questionId]: showContact ? formValues.email : '',
      [questions?.[3]?.questionId]: showContact ? formValues.preferredPhone : '',
      [questions?.[4]?.questionId]: formValues.scenario,
      [questions?.[5]?.questionId]: formValues.screenLocation
    }
  });

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-TOKEN': Config.QUALTRICS_API_TOKEN
    },
    body
  };

  const response = await window.fetch(
    `${SESSION_URL}/${session?.result?.sessionId}`,
    requestOptions
  );
  return response.json();
}

export const getScenarioQuestionText = (scenario: ShareFeedbackScenarios) => {
  if (scenario === SHARE_FEEDBACK_SCENARIOS.shareFeedback) {
    return `We'd love to hear how we can improve ${getAppName(AppName.secondary, 'the')}!`;
  }
  return `We’d love to hear how we can improve the ${lowerCase(scenario)} feature in ${getAppName(
    AppName.secondary,
    'the'
  )}!`;
};

/**
 * Update Qualtrics Session | Submit Feedback Form for Health Tools Survey
 */
export async function updateHealthToolsQualtricsSession(
  formValues: SurveyForm,
  session: QualtricsSession
) {
  const questions = session?.result?.questions;
  const showContact = formValues.radioAnswer === 'Yes';
  const selectedOption = {
    selected: true
  };
  const healthTopicsCheckedArray = {};
  formValues.healthTopicsChecked.forEach(eachCheckedItem => {
    HEALTH_TOPICS_CHECKBOXES.forEach(checkListItem => {
      if (eachCheckedItem === checkListItem.fieldName) {
        Object.assign(healthTopicsCheckedArray, { [checkListItem.key]: selectedOption });
      }
    });
  });
  const payload = {
    advance: true,
    responses: {
      [questions?.[0]?.questionId]: healthTopicsCheckedArray,
      [questions?.[1]?.questionId]: formValues.otherIdea,
      [questions?.[2]?.questionId]: showContact ? { '1': selectedOption } : { '2': selectedOption },
      [questions?.[3]?.questionId]: showContact ? formValues.contactName : '',
      [questions?.[4]?.questionId]: showContact ? formValues.contactEmail : '',
      [questions?.[5]?.questionId]: showContact ? formValues.contactPhone : ''
    }
  };

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-TOKEN': Config.QUALTRICS_API_TOKEN
    },
    body: JSON.stringify(payload)
  };

  const response = await window.fetch(
    `${HEALTHTOOLS_SESSION_URL}/${session?.result?.sessionId}`,
    requestOptions
  );
  return response.json();
}
